import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_RESET_PASSWORD);

var axios_instance_userlist = get_axios_instance(api_variables.SERVICE_SEARCH_EMP_USERLIST); 

const _pk_name = "id";

const state = {
    data: [],
    exits: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

  
}

const actions = {
   
    async create({ commit }, payload) {
        //console.log("[dashboard/organisation/utilities/resetPassword/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200) {
                
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async fetchEmpByName({ commit }, payload) {
        //console.log("[dashboard/organisation/utilities/fetchEmpByName/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance_userlist.get('', {
                params: {
                  key: payload
                }
              });
            commit("setSaving", false);
            if (res.status == 200) {
                
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    
}

export default {
    namespaced: true,
    state, mutations, actions
}